import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1200px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    align-items: flex-end;
  }

  .orders {
    width: 100%;
    overflow-x: auto;
  }

  .titleInput {
    margin-bottom: 5px;
    font-size: 14px;
  }

  .resumo {
    margin-top: 20px;
    font-size: 16px;

    strong {
      font-size: 22px;
      margin-right: 5px;
    }
  }

  .link {
    text-align: center;
    margin: 25px 0;
    font-size: 14px;
    cursor: pointer;
    color: #008037;
    text-decoration: underline;
  }

  .order {
    background-color: #f1f1f1;
    border: 1px solid #0000001c;
    padding: 15px;
    width: 1000px;
    display: flex;
    border-radius: 5px;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-bottom: 10px;

    .title {
      width: 100%;
      margin-bottom: 13px;
      font-weight: 600;
      font-size: 14px;
      text-align: left;
      word-wrap: break-word;
      white-space: normal;
    }

    .row {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }

    .back {
      display: inline-block;
      border-radius: 50px;
      padding: 6px 12px;
      font-size: 13px;
      background-color: #fff;
      margin-left: 25px;

      strong {
        font-size: 16px;
      }
    }

    .backGreen {
      display: inline-block;
      border-radius: 50px;
      padding: 6px 12px;
      font-size: 13px;

      background-color: #40964e;
      color: #fff;
    }

    @media (max-width: 750px) {
      width: 600px;
    }
  }
`;
